import React from 'react';

import { IconProps } from './types';

const HistoryIcon: React.FC<IconProps> = props => {
  const { width = '18', height = '18', fillColor = 'var(--blue-base)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_2163_54456"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="var(--lightgray-base)" />
      </mask>
      <g mask="url(#mask0_2163_54456)">
        <path
          d="M8.66667 7.73333L10.3333 9.4C10.4556 9.52222 10.5167 9.67778 10.5167 9.86667C10.5167 10.0556 10.4556 10.2111 10.3333 10.3333C10.2111 10.4556 10.0556 10.5167 9.86667 10.5167C9.67778 10.5167 9.52222 10.4556 9.4 10.3333L7.53333 8.46667C7.46667 8.4 7.41667 8.325 7.38333 8.24167C7.35 8.15833 7.33333 8.07222 7.33333 7.98333V5.33333C7.33333 5.14444 7.39722 4.98611 7.525 4.85833C7.65278 4.73056 7.81111 4.66667 8 4.66667C8.18889 4.66667 8.34722 4.73056 8.475 4.85833C8.60278 4.98611 8.66667 5.14444 8.66667 5.33333V7.73333ZM8 14C6.65556 14 5.45 13.6028 4.38333 12.8083C3.31667 12.0139 2.6 10.9778 2.23333 9.7C2.17778 9.5 2.19722 9.31111 2.29167 9.13333C2.38611 8.95556 2.53333 8.84444 2.73333 8.8C2.92222 8.75556 3.09167 8.79722 3.24167 8.925C3.39167 9.05278 3.49444 9.21111 3.55 9.4C3.83889 10.3778 4.39722 11.1667 5.225 11.7667C6.05278 12.3667 6.97778 12.6667 8 12.6667C9.3 12.6667 10.4028 12.2139 11.3083 11.3083C12.2139 10.4028 12.6667 9.3 12.6667 8C12.6667 6.7 12.2139 5.59722 11.3083 4.69167C10.4028 3.78611 9.3 3.33333 8 3.33333C7.23333 3.33333 6.51667 3.51111 5.85 3.86667C5.18333 4.22222 4.62222 4.71111 4.16667 5.33333H5.33333C5.52222 5.33333 5.68056 5.39722 5.80833 5.525C5.93611 5.65278 6 5.81111 6 6C6 6.18889 5.93611 6.34722 5.80833 6.475C5.68056 6.60278 5.52222 6.66667 5.33333 6.66667H2.66667C2.47778 6.66667 2.31944 6.60278 2.19167 6.475C2.06389 6.34722 2 6.18889 2 6V3.33333C2 3.14444 2.06389 2.98611 2.19167 2.85833C2.31944 2.73056 2.47778 2.66667 2.66667 2.66667C2.85556 2.66667 3.01389 2.73056 3.14167 2.85833C3.26944 2.98611 3.33333 3.14444 3.33333 3.33333V4.23333C3.9 3.52222 4.59167 2.97222 5.40833 2.58333C6.225 2.19444 7.08889 2 8 2C8.83333 2 9.61389 2.15833 10.3417 2.475C11.0694 2.79167 11.7028 3.21944 12.2417 3.75833C12.7806 4.29722 13.2083 4.93056 13.525 5.65833C13.8417 6.38611 14 7.16667 14 8C14 8.83333 13.8417 9.61389 13.525 10.3417C13.2083 11.0694 12.7806 11.7028 12.2417 12.2417C11.7028 12.7806 11.0694 13.2083 10.3417 13.525C9.61389 13.8417 8.83333 14 8 14Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default HistoryIcon;
